// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__25Rit","dragIcon":"Choice_dragIcon__1jYwi","left":"Choice_left__8radV","input":"Choice_input__2jAUh"};